import '../assets/NcMentionBubble-7PQ8wEko.css';
import { g as c } from "./getAvatarUrl-BHpn8LgJ.mjs";
/* empty css                                                                          */
import { n as u } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import { L as p } from "./Linkify-BaDLLFxP.mjs";
import m from "escape-html";
import a from "striptags";
import d from "vue";
const b = {
  name: "NcMentionBubble",
  props: {
    id: {
      type: String,
      required: !0
    },
    /**
     * @deprecated Use `label` instead
     */
    title: {
      type: String,
      required: !1,
      default: null
    },
    label: {
      type: String,
      required: !1,
      default: null
    },
    icon: {
      type: String,
      required: !0
    },
    iconUrl: {
      type: [String, null],
      default: null
    },
    source: {
      type: String,
      required: !0
    },
    primary: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    avatarUrl() {
      return this.iconUrl ? this.iconUrl : this.id && this.source === "users" ? this.getAvatarUrl(this.id, 44) : null;
    },
    mentionText() {
      return !this.id.includes(" ") && !this.id.includes("/") ? "@".concat(this.id) : '@"'.concat(this.id, '"');
    },
    // Fallback to title for compatibility
    labelWithFallback() {
      return this.label || this.title;
    }
  },
  methods: {
    getAvatarUrl: c
  }
};
var _ = function() {
  var e = this, n = e._self._c;
  return n("span", { staticClass: "mention-bubble", class: { "mention-bubble--primary": e.primary }, attrs: { contenteditable: "false" } }, [n("span", { staticClass: "mention-bubble__wrapper" }, [n("span", { staticClass: "mention-bubble__content" }, [n("span", { staticClass: "mention-bubble__icon", class: [e.icon, "mention-bubble__icon--".concat(e.avatarUrl ? "with-avatar" : "")], style: e.avatarUrl ? { backgroundImage: "url(".concat(e.avatarUrl, ")") } : null }), n("span", { staticClass: "mention-bubble__title", attrs: { role: "heading", title: e.labelWithFallback } })]), n("span", { staticClass: "mention-bubble__select", attrs: { role: "none" } }, [e._v(e._s(e.mentionText))])])]);
}, g = [], f = /* @__PURE__ */ u(
  b,
  _,
  g,
  !1,
  null,
  "791c3b28",
  null,
  null
);
const h = f.exports;
/**
 * @copyright Copyright (c) 2020 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const l = new RegExp("\\B(?<![^a-z0-9_\\-@.'\\s])").source, E = /(@[a-z0-9_\-@.']+)/.source, T = /@&quot;guest\/[a-f0-9]+&quot;/.source, y = /@&quot;(?:federated_)?(?:group|team|user){1}\/[a-z0-9_\-@.' /:]+&quot;/.source, $ = /@&quot;[a-z0-9_\-@.' ]+&quot;/.source, C = "(".concat(T, "|").concat(y, "|").concat($, ")"), v = new RegExp("".concat(l).concat(E), "gi"), N = new RegExp("".concat(l).concat(C), "gi"), O = {
  props: {
    userData: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    /**
     * Convert the value string to html for the inner content
     *
     * @param {string} value the content without html
     * @return {string} rendered html
     */
    renderContent(t) {
      return m(t).split(v).map((r) => r.split(N)).flat().map((r) => {
        if (!r.startsWith("@"))
          return p(r);
        const i = r.slice(1).replace(/&quot;/gi, "");
        return this.genSelectTemplate(i);
      }).join("").replace(/\n/gmi, "<br>").replace(/&amp;/gmi, "&");
    },
    /**
     * Convert the innerHtml content to a string with mentions as text
     *
     * @param {string} content the content without html
     * @return {string}
     */
    parseContent(t) {
      let e = t;
      return e = e.replace(/>\s+</g, "><"), e = e.replace(/<br>/gmi, "\n"), e = e.replace(/&nbsp;/gmi, " "), e = e.replace(/&amp;/gmi, "&"), e = e.replace(/<\/div>/gmi, "\n"), e = a(e, "<div>"), e = a(e), e;
    },
    /**
     * Generate an autocompletion popup entry template
     *
     * @param {string} value the value to match against the userData
     * @return {string}
     */
    genSelectTemplate(t) {
      if (typeof t > "u")
        return "".concat(this.autocompleteTribute.current.collection.trigger).concat(this.autocompleteTribute.current.mentionText);
      const e = this.userData[t];
      return e ? this.renderComponentHtml(e, h).replace(/[\n\t]/gmi, "") : [" ", "/", ":"].every((n) => !t.includes(n)) ? "@".concat(t) : '@"'.concat(t, '"');
    },
    /**
     * Render a component and return its html content
     *
     * @param {object} propsData the props to pass to the component
     * @param {object} component the component to render
     * @return {string} the rendered html
     */
    renderComponentHtml(t, e) {
      const n = d.extend(e), r = new n({
        propsData: t
      }), i = document.createElement("div"), s = document.createElement("div");
      i.style.display = "none", i.appendChild(s), document.body.appendChild(i), r.$mount(s);
      const o = i.innerHTML;
      return r.$destroy(), i.remove(), o;
    }
  }
};
export {
  h as N,
  v as U,
  N as a,
  O as r
};
